var map = {
	"./back.svg": 52881,
	"./logo-bml.svg": 7367,
	"./logo-bw.svg": 83995,
	"./menu.svg": 18973,
	"./share.svg": 19697,
	"./title-bg.svg": 59854
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 31045;